export default __webpack_public_path__ + "static/media/Header-Background.1f9e8ee0.svg";